import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import config from 'utils/config';
export var AccessLink = function AccessLink(_ref) {
  var children = _ref.children,
    accessTabLink = _ref.accessTabLink;
  var location = useLocation();
  if (!config.newPlaylistPage) {
    return /*#__PURE__*/React.createElement(Text, null, children);
  }
  return /*#__PURE__*/React.createElement(TextLink, {
    as: NavLink,
    to: {
      pathname: accessTabLink,
      search: location.search
    },
    bold: true
  }, children);
};